import { NavLink, Outlet } from 'react-router-dom';
import { useState } from 'react';
import './AdminLayout.scss';

export function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className={`admin-layout ${sidebarOpen ? '' : 'admin-layout--collapsed'}`}>
      <aside className="admin-layout__sidebar">
        <div className="admin-layout__sidebar-header">
          <span className="admin-layout__title">Admin</span>
          <button
            className="admin-layout__toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label={sidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
          >
            {sidebarOpen ? '\u2190' : '\u2192'}
          </button>
        </div>
        <nav className="admin-layout__nav">
          <NavLink to="/admin" end className={({ isActive }) => `admin-layout__nav-link ${isActive ? 'admin-layout__nav-link--active' : ''}`} title="Overview">
            <span className="admin-layout__nav-icon">&#9776;</span>
            <span className="admin-layout__nav-text">Overview</span>
          </NavLink>
          <NavLink to="/admin/users" className={({ isActive }) => `admin-layout__nav-link ${isActive ? 'admin-layout__nav-link--active' : ''}`} title="Users">
            <span className="admin-layout__nav-icon">&#9787;</span>
            <span className="admin-layout__nav-text">Users</span>
          </NavLink>
          <NavLink to="/admin/subscriptions" className={({ isActive }) => `admin-layout__nav-link ${isActive ? 'admin-layout__nav-link--active' : ''}`} title="Subscriptions">
            <span className="admin-layout__nav-icon">&#9733;</span>
            <span className="admin-layout__nav-text">Subscriptions</span>
          </NavLink>
        </nav>
      </aside>
      <main className="admin-layout__content">
        <Outlet />
      </main>
    </div>
  );
}
